document.addEventListener('DOMContentLoaded', () => {
  const tbody = document.querySelector('[data-preordine-body]');
  if (!tbody) return;

  // Controlla approvazione: esposta da Liquid tramite window.preordineApproved
  const isPreordineApproved = window.preordineApproved === true;

  const emptyRow = tbody.querySelector('[data-preordine-empty]');
  const loadingEl = emptyRow?.querySelector('[data-preordine-loading]');
  const emptyMsgEl = emptyRow?.querySelector('[data-preordine-empty-msg]');
  const totalsBlocks = document.querySelectorAll('[data-preordine-totals], #preordine-totals');
  const totalValueEls = document.querySelectorAll('[data-preordine-total]');
  const btnPdfs = document.querySelectorAll('[data-preordine-pdf]');
  const btnCarts = document.querySelectorAll('[data-preordine-cart]');
  const bar = document.querySelector('[data-preordine-bar]');
  const searchInput = document.querySelector('[data-preordine-search]');
  const collectionsNav = document.getElementById('preordine-collections-nav');
  const linesNav = document.getElementById('preordine-lines-nav');
  const manualBody = document.querySelector('[data-preordine-manual-body]');
  const addManualLineButton = document.querySelector('[data-preordine-add-manual-line]');
  const quantityState = new Map();
  const extraQuantityState = new Map();
  const manualLines = [];
  const productIndex = new Map();
  let collectionsData = [];
  let activeCollectionFilter = '';
  let activeLineFilter = '';

  const SIDEBAR_BUCKETS = [
    {
      key: 'revivre_viso',
      parentKey: 'revivre',
      parentLabel: 'Revivre',
      label: 'Viso',
      match: /DETODERM|DERMOPURA|HYDRA|COCKTAIL|JOYFUL|ALPHA PRO AGE|DERMOSENSITIVE|LIVIS WHITE|DERMAPULSE|PLATINUM|YSOTHEA/i,
    },
    {
      key: 'revivre_corpo',
      parentKey: 'revivre',
      parentLabel: 'Revivre',
      label: 'Corpo',
      match:
        /MARIS SPA|\bSYN\b|SPECIALE CORPO|R-?SHAPE|NEUROHARMONY|FEETNESS|SAFE SUN|DEPIL LATE|REWAX|FLOSE/i,
    },
    {
      key: 'revivre_capelli',
      parentKey: 'revivre',
      parentLabel: 'Revivre',
      label: 'Capelli',
      match: /EXENCE|ALTA STRUCTA|CHROMATHERAPY|ECLIPSE|VIBRATION|ART PRO|TRICOLOG|CAPELL|HAIR/i,
    },
    {
      key: 'revivre_materiali',
      parentKey: 'revivre',
      parentLabel: 'Revivre',
      label: 'Materiali',
      match: /LOCANDINA|LISTINO|PELLICOLA|BROCHURE|ESPOSITORE|MERCHANDISING|MATERIALE|R-?SHAPE PROFESSIONAL NEW|R-?SHAPE RETAIL NEW|MERCHANDISING R-SHAPE NEW/i,
    },
    {
      key: 'monouso',
      label: 'Monouso',
      match: /\bMONOUSO\b|KIMONO|MANTELLE|PANTALONI|TUTE|CIABATTINE|CUFFIE|FASCE|INTIMO|GUANTI|FOGLI|ACCESSORI CABINA/i,
    },
    {
      key: 'cpm_cosmetica',
      parentKey: 'cpm',
      parentLabel: 'CPM',
      label: 'Cosmetica Professionale',
      match: /CPM COSMETICA PROFESSIONALE/i,
    },
    {
      key: 'cpm_strumenti',
      parentKey: 'cpm',
      parentLabel: 'CPM',
      label: 'Strumenti',
      match: /CPM STRUMENTI/i,
    },
    {
      key: 'cpm_micromotori_frese',
      parentKey: 'cpm',
      parentLabel: 'CPM',
      label: 'Micromotori e Frese',
      match: /CPM MICROMOTORI E FRESE/i,
    },
    {
      key: 'baby_party_no_disney',
      parentKey: 'baby_party',
      parentLabel: 'Baby Party',
      label: 'Non Disney',
      lineFilter: 'TAKE_CARE_NO_DISNEY',
      match: /NO DISNEY/i,
    },
    {
      key: 'baby_party_disney',
      parentKey: 'baby_party',
      parentLabel: 'Baby Party',
      label: 'Disney',
      lineFilter: 'TAKE_CARE_DISNEY',
      match: /DISNEY|HELLO KITTY|MINNIE|MICKEY|KUROMI|MIFFY|CINNAMOROLL/i,
    },
    {
      key: 'review',
      parentKey: 'review',
      parentLabel: 'Review',
      label: 'Da classificare',
      match: /$a/,
    },
  ];

  const SIDEBAR_COLLECTION_BUCKETS = {
    DETODERM_PURIFYING: 'revivre_viso',
    DERMOPURA: 'revivre_viso',
    HYDRA: 'revivre_viso',
    COCKTAIL: 'revivre_viso',
    JOYFUL_NUOVA: 'revivre_viso',
    PLATINUM: 'revivre_viso',
    ALPHA_PRO_AGE: 'revivre_viso',
    DERMOSENSITIVE: 'revivre_viso',
    LIVIS_WHITE: 'revivre_viso',
    DERMAPULSE: 'revivre_viso',
    YSOTHEA: 'revivre_viso',
    MARIS_SPA: 'revivre_corpo',
    SYN: 'revivre_corpo',
    GEL_LASE_RF: 'revivre_corpo',
    R_SHAPE: 'revivre_corpo',
    R_SHAPE_PROFESSIONAL_NEW: 'revivre_corpo',
    R_SHAPE_RETAIL_NEW: 'revivre_corpo',
    NEUROHARMONY: 'revivre_corpo',
    FEETNESS: 'revivre_corpo',
    SAFE_SUN_PROTECTION: 'revivre_corpo',
    SAFE_SUN_PROTECTION_NEW_2025: 'revivre_corpo',
    DEPIL_LATE_PROF: 'revivre_corpo',
    REWAX_BRAZILIAN_STYLE: 'revivre_corpo',
    FLOSE_UOMO_E_DONNA: 'revivre_corpo',
    FLOSE_TISANE_E_INTEGRATORI: 'revivre_corpo',
    FLOSE_IGIENE: 'revivre_corpo',
    CAPELLI_PROFESSIONALE: 'revivre_capelli',
    LOCANDINA_LIFT_UP_FACE_ROLLER: 'revivre_materiali',
    LOCANDINA_A3_J_PROFESSIONALE: 'revivre_materiali',
    SOIN_WAYS: 'revivre_materiali',
    LOCANDINA_A3_SOIN_VITALITE: 'revivre_materiali',
    LISTINO: 'revivre_materiali',
    LOCANDINA_B_B_BRUSHING: 'revivre_materiali',
    LOCANDINA_A3_A4_R_SHAPE: 'revivre_materiali',
    LISTINO_F_R_STRETCH_UP: 'revivre_materiali',
    MERCHANDISING_R_SHAPE_NEW: 'revivre_materiali',
    LOCANDINA_FIRACTIVE_PATCH_A3: 'revivre_materiali',
    ACCESSORI: 'revivre_materiali',
    MONOUSO: 'monouso',
    CPM_COSMETICA_PROFESSIONALE: 'cpm_cosmetica',
    CPM_STRUMENTI: 'cpm_strumenti',
    CPM_MICROMOTORI_E_FRESE: 'cpm_micromotori_frese',
  };

  const LINE_BUCKETS = [
    {
      key: 'cabina_pro',
      label: 'Cabina / Pro',
      match: /(^|[^A-Z0-9])(PROF?\.?|CABINA|PROTIME|PROHYDRA|PROSENSE|PROLIFT|PROEYES|PRODETOX|PROPURE|PRODRAIN|PROCELL|PROFIRM)([^A-Z0-9]|$)/i,
    },
    {
      key: 'retail',
      label: 'Retail',
      match: /(^|[^A-Z0-9])RETAIL([^A-Z0-9]|$)/i,
    },
    {
      key: 'monouso',
      label: 'Monouso',
      match: /KIMONO|MANTELLE|PANTALONI|TUTE|CIABATTINE|CUFFIE|FASCE|INTIMO|GUANTI|FOGLI|ACCESSORI CABINA|DEPILAZIONE/i,
    },
    {
      key: 'supporto',
      label: 'Supporto / Materiali',
      match: /MERCHANDISING|CAMPION|LISTINO|LOCANDINA|BROCHURE|ESPOSITORE|PELLICOLA|MATERIALE/i,
    },
    {
      key: 'altro',
      label: 'Altro',
      match: null,
    },
  ];
  const FLAT_LINE_BUCKETS = [
    {
      key: 'linee',
      label: 'Linee',
      match: null,
    },
  ];
  const HAIR_LINE_ORDER = [
    'EXENCE',
    'ALTA STRUCTA',
    'CHROMATHERAPY',
    'ECLIPSE',
    'VIBRATION',
    'ART PRO',
    'SAFE SUN',
  ];

  // Se non approvato: blocca il carrello e mostra tooltip
  if (!isPreordineApproved) {
    btnCarts.forEach((btn) => {
      if (!btn) return;
      btn.disabled = true;
      btn.title = 'Il carrello è disponibile dopo approvazione del tuo account da parte del team ELS.';
    });
  }

  const jsonUrl =
    window.preordineListinoUrl ||
    (function () {
      const placeholder = document.querySelector('[data-preordine-json-url]');
      return placeholder ? placeholder.getAttribute('data-preordine-json-url') : null;
    })();
  const preorderApiUrl = String(window.preordineApiUrl || '').trim();
  let activePreorder = null;
  const PREORDER_API_TIMEOUT_MS = 12000;

  function getClientDraftId() {
    const key = 'els_preordine_client_draft_id';
    try {
      const current = window.sessionStorage?.getItem(key);
      if (current) return current;
      const next =
        window.crypto && typeof window.crypto.randomUUID === 'function'
          ? window.crypto.randomUUID()
          : `draft-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      window.sessionStorage?.setItem(key, next);
      return next;
    } catch (_) {
      return `draft-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }
  }

  function buildPreorderPayload(items, totalOrder) {
    const customer = getCustomerInfo();
    return {
      client_draft_id: getClientDraftId(),
      source: 'listino_preordine',
      customer,
      items,
      totals: {
        subtotal: totalOrder,
        total: totalOrder,
        currency: 'EUR',
      },
      created_at: new Date().toISOString(),
      storefront: {
        path: window.location.pathname,
        approved: isPreordineApproved,
      },
    };
  }

  async function createServerPreorder(items, totalOrder) {
    if (!preorderApiUrl) return null;
    if (activePreorder?.preorder_number) return activePreorder;

    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), PREORDER_API_TIMEOUT_MS);
    let response;
    try {
      response = await fetch(preorderApiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(buildPreorderPayload(items, totalOrder)),
        credentials: 'omit',
        signal: controller.signal,
      });
    } finally {
      window.clearTimeout(timeoutId);
    }
    const payload = await response.json().catch(() => ({}));
    if (!response.ok || !payload?.preorder_number) {
      throw new Error(payload?.error || 'preorder_create_failed');
    }
    activePreorder = payload;
    return activePreorder;
  }

  async function updateServerPreorderStatus(status) {
    if (!preorderApiUrl || !activePreorder?.preorder_number) return;
    const statusUrl = preorderApiUrl.replace(/\/+$/, '') + `/${encodeURIComponent(activePreorder.preorder_number)}/status`;
    try {
      await fetch(statusUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ status }),
        credentials: 'omit',
      });
    } catch (error) {
      console.warn('Aggiornamento stato preordine non riuscito', error);
    }
  }

  function setLoading(isLoading) {
    if (!emptyRow) return;
    if (isLoading) {
      emptyRow.dataset.empty = 'false';
      if (loadingEl) loadingEl.classList.remove('visually-hidden');
      if (emptyMsgEl) emptyMsgEl.classList.add('visually-hidden');
    }
  }

  function setEmptyState(isEmpty) {
    if (!emptyRow) return;
    emptyRow.dataset.empty = isEmpty ? 'true' : 'false';
    if (isEmpty) {
      if (loadingEl) loadingEl.classList.add('visually-hidden');
      if (emptyMsgEl) emptyMsgEl.classList.remove('visually-hidden');
    } else {
      emptyRow.remove();
    }
  }

  function formatPrice(value) {
    try {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
      }).format(value);
    } catch (e) {
      return value.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function normalizeCollectionKey(value) {
    return String(value || '')
      .toUpperCase()
      .trim()
      .replace(/[^A-Z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function normalizeLineKey(value) {
    return normalizeCollectionKey(value);
  }

  function normalizeLineLabel(value) {
    return String(value || '')
      .trim()
      .replace(/[.\s]+$/g, '')
      .replace(/\s+/g, ' ');
  }

  function compareSkuValues(a, b) {
    const left = String(a || '').trim().toUpperCase();
    const right = String(b || '').trim().toUpperCase();
    const leftMatch = left.match(/(\d+)/);
    const rightMatch = right.match(/(\d+)/);
    if (leftMatch && rightMatch && leftMatch[1] !== rightMatch[1]) {
      const leftNum = parseInt(leftMatch[1], 10);
      const rightNum = parseInt(rightMatch[1], 10);
      if (Number.isFinite(leftNum) && Number.isFinite(rightNum) && leftNum !== rightNum) {
        return leftNum - rightNum;
      }
    }
    return left.localeCompare(right, 'it-IT', { numeric: true, sensitivity: 'base' });
  }

  function compareLineLabels(a, b) {
    const left = String(a || '').trim();
    const right = String(b || '').trim();
    const leftUpper = left.toUpperCase();
    const rightUpper = right.toUpperCase();
    const leftRank = HAIR_LINE_ORDER.findIndex((token) => leftUpper.includes(token));
    const rightRank = HAIR_LINE_ORDER.findIndex((token) => rightUpper.includes(token));
    const normalizedLeftRank = leftRank === -1 ? HAIR_LINE_ORDER.length : leftRank;
    const normalizedRightRank = rightRank === -1 ? HAIR_LINE_ORDER.length : rightRank;
    if (normalizedLeftRank !== normalizedRightRank) {
      return normalizedLeftRank - normalizedRightRank;
    }
    return left.localeCompare(right, 'it-IT', { numeric: true, sensitivity: 'base' });
  }

  function classifySidebarBucket(collection) {
    const collectionName = String(collection?.collezione || '').trim();
    const canonicalBucketKey = SIDEBAR_COLLECTION_BUCKETS[normalizeCollectionKey(collectionName)];
    if (canonicalBucketKey) {
      const canonicalBucket = SIDEBAR_BUCKETS.find((bucket) => bucket.key === canonicalBucketKey);
      if (canonicalBucket) return canonicalBucket;
    }

    const lineNames = Array.isArray(collection?.linee)
      ? collection.linee.map((line) => String(line?.linea || '').trim()).filter(Boolean)
      : [];
    const haystack = [collectionName, ...lineNames].join(' | ');

    for (const bucket of SIDEBAR_BUCKETS) {
      if (bucket.match.test(haystack)) return bucket;
    }
    return {
      key: 'review',
      parentKey: 'review',
      parentLabel: 'Review',
      label: 'Da classificare',
      match: null,
    };
  }

  function groupCollectionsForSidebar(collections) {
    const groups = new Map();

    SIDEBAR_BUCKETS.forEach((bucket) => {
      groups.set(bucket.key, {
        ...bucket,
        collections: [],
      });
    });

    collections.forEach((collection) => {
      const collectionName = String(collection?.collezione || '').trim();
      const isBabyParty = /BABY PARTY|POLYFLAME|TAKE CARE/i.test(collectionName);
      if (isBabyParty && Array.isArray(collection?.linee)) {
        collection.linee.forEach((line) => {
          const lineName = String(line?.linea || '').trim();
          const bucketKey = /NO DISNEY/i.test(lineName) ? 'baby_party_no_disney' : /DISNEY/i.test(lineName) ? 'baby_party_disney' : '';
          if (!bucketKey || !groups.has(bucketKey)) return;
          const bucket = groups.get(bucketKey);
          bucket.collections.push({
            ...collection,
            sidebarLabel: lineName,
            sidebarLineFilter: bucket.lineFilter || normalizeLineKey(lineName),
          });
        });
        return;
      }

      const bucket = classifySidebarBucket(collection);
      if (!groups.has(bucket.key)) {
        groups.set(bucket.key, { ...bucket, collections: [] });
      }
      groups.get(bucket.key).collections.push(collection);
    });

    return Array.from(groups.values()).filter((bucket) => bucket.collections.length > 0);
  }

  function shouldUseFlatLineBuckets(collection) {
    const collectionName = String(collection?.collezione || '').trim();
    const sidebarBucket = SIDEBAR_COLLECTION_BUCKETS[normalizeCollectionKey(collectionName)] || '';
    return (
      collectionName === 'Baby Party' ||
      sidebarBucket === 'monouso' ||
      sidebarBucket === 'revivre_materiali' ||
      sidebarBucket.startsWith('cpm_')
    );
  }

  function classifyLineBucket(lineName, buckets) {
    const normalized = String(lineName || '').trim();
    for (const bucket of buckets) {
      if (!bucket.match) continue;
      if (bucket.match.test(normalized)) return bucket;
    }
    return buckets[buckets.length - 1];
  }

  function groupLinesForNav(lines, collection) {
    const buckets = shouldUseFlatLineBuckets(collection) ? FLAT_LINE_BUCKETS : LINE_BUCKETS;
    const groups = new Map();

    buckets.forEach((bucket) => {
      groups.set(bucket.key, {
        ...bucket,
        lines: [],
      });
    });

    (Array.isArray(lines) ? lines : []).forEach((line) => {
      const label = String(line?.linea || '').trim();
      if (!label) return;
      const bucket = classifyLineBucket(label, buckets);
      if (!groups.has(bucket.key)) {
        groups.set(bucket.key, { ...bucket, lines: [] });
      }
      groups.get(bucket.key).lines.push(line);
    });

    return Array.from(groups.values())
      .filter((bucket) => bucket.lines.length > 0)
      .map((bucket) => ({
        ...bucket,
        lines: bucket.lines.slice().sort((a, b) => {
          const leftOrder = Number.isFinite(Number(a?.ordine)) ? Number(a.ordine) : Number.POSITIVE_INFINITY;
          const rightOrder = Number.isFinite(Number(b?.ordine)) ? Number(b.ordine) : Number.POSITIVE_INFINITY;
          if (leftOrder !== rightOrder) return leftOrder - rightOrder;
          return compareLineLabels(a?.linea, b?.linea);
        }),
      }));
  }

  function syncLineGroupState() {
    const groups = document.querySelectorAll('[data-line-bucket]');
    if (!groups.length) return;

    groups.forEach((group, index) => {
      const containsActive = Array.from(group.querySelectorAll('[data-line-filter]')).some((btn) => {
        return (btn.getAttribute('data-line-filter') || '') === activeLineFilter;
      });
      group.open = activeLineFilter ? containsActive : index === 0;
    });
  }

  function syncSidebarGroupState() {
    const groups = document.querySelectorAll('[data-sidebar-bucket]');
    if (!groups.length) return;

    groups.forEach((group) => {
      const containsActive = Array.from(group.querySelectorAll('[data-collection-filter]')).some((btn) => {
        const collectionMatches = (btn.getAttribute('data-collection-filter') || '') === activeCollectionFilter;
        const lineFilter = btn.getAttribute('data-line-filter') || '';
        return collectionMatches && (!lineFilter || lineFilter === activeLineFilter);
      });
      group.open = activeCollectionFilter ? containsActive : group.dataset.sidebarBucket === 'revivre';
    });
  }

  function getActiveCollection() {
    if (!collectionsData.length) return null;
    return (
      collectionsData.find(
        (collection) => normalizeCollectionKey(collection.collezione) === activeCollectionFilter
      ) || collectionsData[0]
    );
  }

  function getSearchQuery() {
    return (searchInput?.value || '').trim().toLowerCase();
  }

  function buildNoResultsRow(message) {
    const tr = document.createElement('tr');
    tr.className = 'preordine__empty';
    const td = document.createElement('td');
    td.colSpan = 5;
    td.className = 'preordine__empty-cell';
    td.textContent = message;
    tr.appendChild(td);
    return tr;
  }

  function getSelectedCodes() {
    const codes = new Set();
    quantityState.forEach((qty, code) => {
      if (qty > 0) codes.add(code);
    });
    extraQuantityState.forEach((qty, code) => {
      if (qty > 0) codes.add(code);
    });
    return Array.from(codes);
  }

  function attachCollectionFilterHandlers() {
    const collectionButtons = document.querySelectorAll('[data-collection-filter]');
    if (!collectionButtons.length) return;
    collectionButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        collectionButtons.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        activeCollectionFilter = btn.getAttribute('data-collection-filter') || '';
        activeLineFilter = btn.getAttribute('data-line-filter') || '';
        renderDynamicLineFilters(collectionsData, activeCollectionFilter);
        renderVisibleRows();
        syncSidebarGroupState();
      });
    });
  }

  function renderDynamicCollectionFilters(collections) {
    if (!collectionsNav) return;
    const fragment = document.createDocumentFragment();

    const groupedCollections = groupCollectionsForSidebar(collections);
    const parentGroups = new Map();
    groupedCollections.forEach((bucket) => {
      const parentKey = bucket.parentKey || bucket.key;
      if (!parentGroups.has(parentKey)) {
        parentGroups.set(parentKey, {
          key: parentKey,
          label: bucket.parentLabel || bucket.label,
          buckets: [],
          collections: [],
        });
      }
      const parent = parentGroups.get(parentKey);
      parent.buckets.push(bucket);
      parent.collections.push(...bucket.collections);
    });

    Array.from(parentGroups.values()).forEach((parent) => {
      const details = document.createElement('details');
      details.className = 'preordine__sidebar-group';
      details.dataset.sidebarBucket = parent.key;
      details.open = activeCollectionFilter
        ? parent.collections.some((collection) => normalizeCollectionKey(collection.collezione) === activeCollectionFilter)
        : parent.key === 'revivre';

      const summary = document.createElement('summary');
      summary.className = 'preordine__sidebar-group-summary';
      const count = parent.collections.length;
      summary.innerHTML = `<span>${parent.label.toUpperCase()}</span><span class="preordine__sidebar-group-count">${count}</span>`;
      details.appendChild(summary);

      const items = document.createElement('div');
      items.className = 'preordine__sidebar-group-items';
      parent.buckets.forEach((bucket) => {
        const nested = parent.buckets.length > 1 && parent.key !== 'cpm';
        const bucketContainer = nested ? document.createElement('details') : items;
        if (nested) {
          bucketContainer.className = 'preordine__sidebar-group preordine__sidebar-group--nested';
          bucketContainer.dataset.sidebarBucket = bucket.key;
          bucketContainer.open = activeCollectionFilter
            ? bucket.collections.some((collection) => {
                const collectionMatches = normalizeCollectionKey(collection.collezione) === activeCollectionFilter;
                const lineFilter = collection.sidebarLineFilter || '';
                return collectionMatches && (!lineFilter || lineFilter === activeLineFilter);
              })
            : bucket.key === 'revivre_viso';
          const nestedSummary = document.createElement('summary');
          nestedSummary.className = 'preordine__sidebar-group-summary';
          nestedSummary.innerHTML = `<span>${bucket.label.toUpperCase()}</span><span class="preordine__sidebar-group-count">${bucket.collections.length}</span>`;
          bucketContainer.appendChild(nestedSummary);
        }

        const bucketItems = nested ? document.createElement('div') : items;
        if (nested) bucketItems.className = 'preordine__sidebar-group-items';
        bucket.collections.forEach((collection) => {
          const key = normalizeCollectionKey(collection.collezione);
          if (!key) return;
          const lineFilter = collection.sidebarLineFilter || '';
          const isActive = key === activeCollectionFilter && (!lineFilter || lineFilter === activeLineFilter);
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = `preordine__line-btn${isActive ? ' is-active' : ''}`;
          btn.setAttribute('data-collection-filter', key);
          if (lineFilter) btn.setAttribute('data-line-filter', lineFilter);
          const label =
            collection.sidebarLabel || (parent.key === 'cpm' ? bucket.label : collection.collezione) || '';
          btn.textContent = String(label).toUpperCase();
          bucketItems.appendChild(btn);
        });

        if (nested) {
          bucketContainer.appendChild(bucketItems);
          items.appendChild(bucketContainer);
        }
      });

      details.appendChild(items);
      fragment.appendChild(details);
    });

    collectionsNav.innerHTML = '';
    collectionsNav.appendChild(fragment);
    attachCollectionFilterHandlers();
    syncSidebarGroupState();
  }

  function attachLineFilterHandlers() {
    const lineButtons = document.querySelectorAll('[data-line-filter]');
    if (!lineButtons.length) return;
    lineButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        lineButtons.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        activeLineFilter = btn.getAttribute('data-line-filter') || '';
        renderVisibleRows();
        syncLineGroupState();
      });
    });
  }

  function attachLineGroupHandlers() {
    const groupSummaries = document.querySelectorAll('[data-line-bucket] > summary');
    if (!groupSummaries.length) return;

    groupSummaries.forEach((summary) => {
      summary.addEventListener('click', () => {
        const parent = summary.parentElement;
        if (!parent) return;
        const lineButtons = parent.querySelectorAll('[data-line-filter]');
        if (lineButtons.length === 1) {
          const onlyButton = lineButtons[0];
          const key = onlyButton.getAttribute('data-line-filter') || '';
          if (key) {
            activeLineFilter = key;
            lineButtons.forEach((btn) => btn.classList.remove('is-active'));
            onlyButton.classList.add('is-active');
            renderVisibleRows();
            syncLineGroupState();
          }
        }
      });
    });
  }

  function renderDynamicLineFilters(collections, collectionKey) {
    if (!linesNav) return;

    const fragment = document.createDocumentFragment();
    const allBtn = document.createElement('button');
    allBtn.type = 'button';
    allBtn.className = `preordine__line-reset${activeLineFilter ? '' : ' is-active'}`;
    allBtn.setAttribute('data-line-filter', '');
    allBtn.textContent = 'TUTTE LE LINEE';
    fragment.appendChild(allBtn);

    const activeCollection = collections.find(
      (collection) => normalizeCollectionKey(collection.collezione) === collectionKey
    ) || collections[0];

    if (activeCollection && Array.isArray(activeCollection.linee)) {
      const groupedLines = groupLinesForNav(activeCollection.linee, activeCollection);
      groupedLines.forEach((bucket) => {
        const details = document.createElement('details');
        details.className = 'preordine__line-group';
        details.dataset.lineBucket = bucket.key;

        const summary = document.createElement('summary');
        summary.className = 'preordine__line-group-summary';
        summary.innerHTML = `<span>${bucket.label.toUpperCase()}</span><span class="preordine__line-group-count">${bucket.lines.length}</span>`;
        details.appendChild(summary);

        const items = document.createElement('div');
        items.className = 'preordine__line-group-items';
        bucket.lines.forEach((line) => {
          const key = normalizeLineKey(line.linea);
          if (!key) return;
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = `preordine__line-btn${key === activeLineFilter ? ' is-active' : ''}`;
          btn.setAttribute('data-line-filter', key);
          btn.textContent = String(line.linea || '').toUpperCase();
          items.appendChild(btn);
        });

        details.appendChild(items);
        fragment.appendChild(details);
      });
    }

    linesNav.innerHTML = '';
    linesNav.appendChild(fragment);
    attachLineFilterHandlers();
    attachLineGroupHandlers();
    syncLineGroupState();
  }

  function recalcTotal() {
    let total = 0;
    let hasSelection = false;
    let hasCartSelection = false;

    quantityState.forEach((qty, code) => {
      if (qty <= 0) return;
      hasSelection = true;
      const product = productIndex.get(code);
      const status = String(product?.shopify_status || '').trim().toLowerCase();
      const handle = String(product?.handle || '').trim();
      if (handle && status !== 'missing' && status !== 'draft') {
        hasCartSelection = true;
      }
      const price = parseFloat(product?.prezzo ?? 0) || 0;
      if (price > 0) {
        total += qty * price;
      }
    });

    manualLines.forEach((line) => {
      if ((line.quantita || 0) > 0 || (line.quantitaExtra || 0) > 0) {
        hasSelection = true;
        if (isPreordineApproved && line.prezzo > 0) {
          total += line.quantita * line.prezzo;
        }
      }
    });

    if (!hasSelection) {
      extraQuantityState.forEach((qty) => {
        if (qty > 0) hasSelection = true;
      });
    }

    totalsBlocks.forEach((el) => {
      if (!el) return;
      el.hidden = !hasSelection;
    });

    totalValueEls.forEach((el) => {
      if (!el) return;
      el.textContent = formatPrice(total);
    });

    btnPdfs.forEach((btn) => {
      if (!btn) return;
      btn.disabled = !hasSelection;
    });

    btnCarts.forEach((btn) => {
      if (!btn) return;
      // Keep cart action strictly bound to B2B authorization.
      btn.disabled = !hasCartSelection || !isPreordineApproved;
    });

    if (bar) {
      bar.hidden = !hasSelection;
      if (!hasSelection) {
        document.documentElement.style.removeProperty('--preordine-bar-h');
        document.body.style.paddingBottom = '';
      } else {
        requestAnimationFrame(() => {
          const h = bar.offsetHeight;
          document.documentElement.style.setProperty('--preordine-bar-h', h + 'px');
          document.body.style.paddingBottom = h + 'px';
        });
      }
    }
  }

  function collectSelectedItems() {
    const items = [];
    getSelectedCodes().forEach((code) => {
      const qty = quantityState.get(code) || 0;
      const extraQty = extraQuantityState.get(code) || 0;
      if (qty <= 0 && extraQty <= 0) return;
      const product = productIndex.get(code);
      if (!product) return;

      const price = parseFloat(product.prezzo ?? 0) || 0;
      const hasCommercialPrice = product.prezzo !== null && product.prezzo !== undefined && product.prezzo !== '';
      items.push({
        collezione: (product.collezione || '').trim(),
        linea: (product.linea || '').trim(),
        codice: (product.codice || product.sku || '').trim(),
        nome: (product.nome || '').trim(),
        ml: String(product.ml != null ? product.ml : product.formato || '').trim(),
        handle: (product.handle || '').trim(),
        venditore: (product.venditore || '').trim(),
        shopifyStatus: (product.shopify_status || '').trim(),
        prezzo: price,
        hasCommercialPrice,
        quantita: qty,
        quantitaExtra: extraQty,
        totale: hasCommercialPrice && price > 0 ? qty * price : 0,
      });
    });

    manualLines.forEach((line) => {
      const quantita = parseFloat(line.quantita || 0) || 0;
      const quantitaExtra = parseFloat(line.quantitaExtra || 0) || 0;
      if (quantita <= 0 && quantitaExtra <= 0) return;
      const prezzo = parseFloat(line.prezzo || 0) || 0;
      items.push({
        collezione: 'Nuove Varie',
        linea: 'Linea d\'ordine manuale',
        codice: line.codice || '',
        nome: line.nome || '',
        ml: '',
        handle: '',
        venditore: 'Nuove Varie',
        shopifyStatus: 'manual',
        prezzo,
        hasCommercialPrice: isPreordineApproved && prezzo > 0,
        quantita,
        quantitaExtra,
        totale: isPreordineApproved && prezzo > 0 ? quantita * prezzo : 0,
        manuale: true,
      });
    });

    return items;
  }

  function getCustomerInfo() {
    return {
      nome: (document.querySelector('[data-preordine-customer-name]')?.value || '').trim(),
      azienda: (document.querySelector('[data-preordine-customer-company]')?.value || '').trim(),
      telefono: (document.querySelector('[data-preordine-customer-phone]')?.value || '').trim(),
      email: (document.querySelector('[data-preordine-customer-email]')?.value || '').trim(),
      partitaIva: (document.querySelector('[data-preordine-customer-vat]')?.value || '').trim(),
      codiceFiscale: (document.querySelector('[data-preordine-customer-tax-code]')?.value || '').trim(),
      indirizzoConsegna: (document.querySelector('[data-preordine-customer-delivery-address]')?.value || '').trim(),
      iban: (document.querySelector('[data-preordine-customer-iban]')?.value || '').trim(),
      sdiPec: (document.querySelector('[data-preordine-customer-fiscal]')?.value || '').trim(),
      noteAmministrative: (document.querySelector('[data-preordine-customer-admin-notes]')?.value || '').trim(),
    };
  }

  function groupItemsByVendor(items) {
    const groups = new Map();
    items.forEach((item) => {
      const key = String(item?.venditore || '').trim() || '__default__';
      if (!groups.has(key)) {
        groups.set(key, {
          key,
          items: [],
        });
      }
      groups.get(key).items.push(item);
    });

    return Array.from(groups.values()).map((group, index) => ({
      ...group,
      blockLabel: `Blocco ${index + 1}`,
      subtotal: group.items.reduce((sum, item) => sum + (item.totale || 0), 0),
    }));
  }

  function buildPlainText(items, totalOrder, dateStr, preorderNumber = '') {
    const customer = getCustomerInfo();
    const groupedItems = groupItemsByVendor(items);
    let text = '';
    text += `Pre-ordine ELS\n`;
    if (preorderNumber) text += `Numero preordine: ${preorderNumber}\n`;
    text += `Data: ${dateStr}\n`;
    if (customer.nome) text += `Nome / Referente: ${customer.nome}\n`;
    if (customer.azienda) text += `Societa' / Centro: ${customer.azienda}\n`;
    if (customer.telefono) text += `Telefono: ${customer.telefono}\n`;
    if (customer.email) text += `Email: ${customer.email}\n`;
    if (customer.partitaIva) text += `Partita IVA: ${customer.partitaIva}\n`;
    if (customer.codiceFiscale) text += `Codice fiscale: ${customer.codiceFiscale}\n`;
    if (customer.indirizzoConsegna) text += `Indirizzo consegna: ${customer.indirizzoConsegna}\n`;
    if (customer.iban) text += `Banca / IBAN: ${customer.iban}\n`;
    if (customer.sdiPec) text += `SDI o PEC: ${customer.sdiPec}\n`;
    if (customer.noteAmministrative) text += `Fatturazione / pagamento: ${customer.noteAmministrative}\n`;
    text += '\n';

    if (isPreordineApproved) {
      groupedItems.forEach((group) => {
        text += `${group.blockLabel}\n`;
        text += 'LINEA | CODICE | PRODOTTO | ML | PREZZO | QUANTITÀ TOTALI | TOTALE RIGA\n';
        text += '--------------------------------------------------------------------------------\n';
        group.items.forEach((item) => {
          const linea = item.linea || '-';
          const codice = item.codice || '-';
          const nome = item.nome || '-';
          const ml = item.ml || '-';
          const prezzo = item.hasCommercialPrice ? formatPrice(item.prezzo).replace(/\s*€/, ' €') : '-';
          const qtaTotale = String((item.quantita || 0) + (item.quantitaExtra || 0));
          const tot = item.hasCommercialPrice ? formatPrice(item.totale).replace(/\s*€/, ' €') : '-';
          text += `${linea} | ${codice} | ${nome} | ${ml} | ${prezzo} | ${qtaTotale} | ${tot}\n`;
        });
        text += '--------------------------------------------------------------------------------\n';
        text += `SUBTOTALE ${group.blockLabel.toUpperCase()}: ${formatPrice(group.subtotal)}\n\n`;
      });
      text += `TOTALE PRE-ORDINE: ${formatPrice(totalOrder)}\n`;
    } else {
      // Prospect: no prezzi nel testo
      groupedItems.forEach((group) => {
        text += `${group.blockLabel}\n`;
        text += 'LINEA | CODICE | PRODOTTO | QUANTITÀ TOTALI\n';
        text += '----------------------------------------------------------------\n';
        group.items.forEach((item) => {
          const linea = item.linea || '-';
          const codice = item.codice || '-';
          const nome = String(item.nome || '-').toUpperCase();
          const qtaTotale = String((item.quantita || 0) + (item.quantitaExtra || 0));
          text += `${linea} | ${codice} | ${nome} | ${qtaTotale}\n`;
        });
        text += '----------------------------------------------------------------\n\n';
      });
      text += 'NOTA: Un referente ELS ti contattera\' per la quotazione.\n';
    }

    return text;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function nl2br(value) {
    return escapeHtml(value).replace(/\n/g, '<br>');
  }

  function buildCustomerDetailsHtml(customer, preorderNumber = '') {
    const rows = [];
    if (preorderNumber) rows.push(['Numero preordine', escapeHtml(preorderNumber)]);
    if (customer.azienda) rows.push(['Societa / Centro', escapeHtml(customer.azienda)]);
    if (customer.nome) rows.push(['Nome / Referente', escapeHtml(customer.nome)]);
    if (customer.telefono) rows.push(['Telefono', escapeHtml(customer.telefono)]);
    if (customer.email) rows.push(['Email', escapeHtml(customer.email)]);
    if (customer.partitaIva) rows.push(['Partita IVA', escapeHtml(customer.partitaIva)]);
    if (customer.codiceFiscale) rows.push(['Codice fiscale', escapeHtml(customer.codiceFiscale)]);
    if (customer.indirizzoConsegna) rows.push(['Indirizzo consegna', nl2br(customer.indirizzoConsegna)]);
    if (customer.iban) rows.push(['Banca / IBAN', escapeHtml(customer.iban)]);
    if (customer.sdiPec) rows.push(['SDI o PEC', escapeHtml(customer.sdiPec)]);
    if (customer.noteAmministrative) rows.push(['Fatturazione / pagamento', nl2br(customer.noteAmministrative)]);

    if (!rows.length) return '';

    return `<div class="customer-meta">
      ${rows
        .map(([label, value]) => `<div class="customer-meta__row"><span class="customer-meta__label">${label}</span><strong class="customer-meta__value">${value}</strong></div>`)
        .join('')}
    </div>`;
  }

  function buildSummaryTableRows(items) {
    return items
      .map((item) => {
        const linea = item.linea || '-';
        const codice = item.codice || '-';
        const nome = String(item.nome || '-').toUpperCase();
        const ml = item.ml || '-';
        const qtaTotale = String((item.quantita || 0) + (item.quantitaExtra || 0));
        if (isPreordineApproved) {
          const prezzo = item.hasCommercialPrice ? formatPrice(item.prezzo) : '-';
          const tot = item.hasCommercialPrice ? formatPrice(item.totale) : '-';
          return `<tr>
            <td><span class="linea">${escapeHtml(linea)}</span></td>
            <td>${escapeHtml(codice)}</td>
            <td><span class="product-name">${escapeHtml(nome)}</span></td>
            <td class="right num-col">${escapeHtml(ml)}</td>
            <td class="right num-col col-price">${escapeHtml(prezzo)}</td>
            <td class="right num-col col-qty">${escapeHtml(qtaTotale)}</td>
            <td class="right num-col col-total">${escapeHtml(tot)}</td>
          </tr>`;
        }

        return `<tr>
          <td><span class="linea">${escapeHtml(linea)}</span></td>
          <td>${escapeHtml(codice)}</td>
          <td><span class="product-name">${escapeHtml(nome)}</span></td>
          <td class="right num-col">${escapeHtml(ml)}</td>
          <td class="right num-col col-qty">${escapeHtml(qtaTotale)}</td>
        </tr>`;
      })
      .join('');
  }

  function buildSummaryBlocksHtml(items) {
    const groupedItems = groupItemsByVendor(items);
    return groupedItems
      .map((group) => {
        const subtotalHtml = isPreordineApproved
          ? `<div class="summary-block__subtotal"><span>Subtotale ${group.blockLabel.toLowerCase()}</span><strong>${escapeHtml(formatPrice(group.subtotal))}</strong></div>`
          : '';
        return `<section class="summary-block">
          <div class="summary-block__header">
            <h2 class="summary-block__title">${escapeHtml(group.blockLabel)}</h2>
          </div>
          <table>
            <thead>
              <tr>
                <th>Linea</th>
                <th>Codice</th>
                <th>Prodotto</th>
                <th class="right num-col">ML</th>
                ${isPreordineApproved ? '<th class="right num-col col-price">Prezzo</th>' : ''}
                <th class="right num-col col-qty">Quantità totali</th>
                ${isPreordineApproved ? '<th class="right num-col col-total">Totale</th>' : ''}
              </tr>
            </thead>
            <tbody>
              ${buildSummaryTableRows(group.items)}
            </tbody>
          </table>
          ${subtotalHtml}
        </section>`;
      })
      .join('');
  }

  async function addToCartSelected(event) {
    event.preventDefault();
    const items = collectSelectedItems();
    if (!items.length) {
      alert('Nessun prodotto selezionato.');
      return;
    }
    const totalOrder = isPreordineApproved
      ? items.reduce((sum, it) => sum + it.totale, 0)
      : 0;
    let preorder = activePreorder;
    try {
      preorder = await createServerPreorder(items, totalOrder);
    } catch (error) {
      console.error('Creazione numero preordine non riuscita', error);
      preorder = null;
    }

    // Raggruppa per handle per ridurre le chiamate a /product.js
    const byHandle = {};
    const nonCartableItems = [];
    items.forEach((item) => {
      const shopifyStatus = String(item.shopifyStatus || '').trim().toLowerCase();
      if (!item.hasCommercialPrice || !item.handle || shopifyStatus === 'missing' || shopifyStatus === 'draft') {
        nonCartableItems.push(item);
        return;
      }
      if (!byHandle[item.handle]) byHandle[item.handle] = [];
      byHandle[item.handle].push(item);
    });

    const handles = Object.keys(byHandle);
    if (!handles.length) {
      alert('I prodotti selezionati non risultano ancora collegati ai prodotti Shopify. Genera il pre-ordine PDF e usa il riepilogo come riferimento operativo.');
      return;
    }

    const productsByHandle = {};
    try {
      await Promise.all(
        handles.map(async (handle) => {
          // su Shopify i prodotti sono esposti come /products/{handle}.js
          const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
          if (!res.ok) return;
          const product = await res.json();
          productsByHandle[handle] = product;
        })
      );
    } catch (e) {
      console.error('Errore nel recupero prodotti per il carrello', e);
      alert('Errore nel recupero dei prodotti per il carrello.');
      return;
    }

    const cartItems = [];
    items.forEach((item) => {
      if (!item.handle) return;
      const product = productsByHandle[item.handle];
      if (!product || !Array.isArray(product.variants) || !product.variants.length) return;

      // 1) tenta match preciso per SKU
      let variant = product.variants.find((v) => (v.sku || '').trim() === item.codice);
      if (!variant && product.variants.length === 1) {
        variant = product.variants[0];
      }
      // 2) se non troviamo nulla e il prodotto ha più varianti, meglio saltare l'articolo che aggiungere il prodotto sbagliato
      if (!variant) {
        console.warn('Variant non trovata per SKU', item.codice, 'handle', item.handle, '- articolo escluso dal carrello');
        nonCartableItems.push(item);
        return;
      }

      if (!variant || !variant.id) return;

      cartItems.push({
        id: variant.id,
        quantity: item.quantita,
      });
    });

    if (!cartItems.length) {
      alert('Non è stato possibile associare le varianti Shopify agli SKU selezionati.');
      return;
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: cartItems }),
        credentials: 'same-origin',
      });
      if (!res.ok) {
        console.error('Errore risposta /cart/add.js', await res.text());
        alert('Impossibile aggiungere i prodotti al carrello.');
        return;
      }
      // Salva dati cliente come attributi carrello: visibili nell'ordine e utili per spedizione
      const customer = getCustomerInfo();
      const attrs = {};
      if (customer.nome) attrs['Referente'] = customer.nome;
      if (customer.azienda) attrs['Azienda'] = customer.azienda;
      if (customer.telefono) attrs['Telefono'] = customer.telefono;
      if (customer.email) attrs['Email'] = customer.email;
      if (customer.partitaIva) attrs['Partita IVA'] = customer.partitaIva;
      if (customer.codiceFiscale) attrs['Codice fiscale'] = customer.codiceFiscale;
      if (preorder?.preorder_number) attrs['Numero preordine'] = preorder.preorder_number;
      if (!preorder?.preorder_number) {
        attrs['Riferimento preordine'] = getClientDraftId();
        attrs['Stato preordine'] = 'Numero preordine non generato';
      }
      if (customer.indirizzoConsegna) attrs['Indirizzo consegna'] = customer.indirizzoConsegna;
      if (customer.iban) attrs['Banca / IBAN'] = customer.iban;
      if (customer.sdiPec) attrs['SDI o PEC'] = customer.sdiPec;
      if (customer.noteAmministrative) attrs['Fatturazione / pagamento'] = customer.noteAmministrative;
      const extraSelections = items
        .filter((item) => item.quantitaExtra > 0)
        .map((item) => `${item.codice} (+${item.quantitaExtra})`);
      if (extraSelections.length) attrs['Selezione extra'] = extraSelections.join(', ');
      if (Object.keys(attrs).length) {
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: attrs }),
            credentials: 'same-origin',
          });
        } catch (_) { /* non bloccare il redirect */ }
      }
      if (nonCartableItems.length) {
        alert('Alcuni articoli non sono ancora presenti in Shopify e non sono stati aggiunti al carrello. Il PDF riepilogativo resta il riferimento operativo completo.');
      }
      if (preorder?.preorder_number) {
        await updateServerPreorderStatus('cart_created');
      }
      window.location.href = '/cart';
    } catch (e) {
      console.error('Errore chiamata /cart/add.js', e);
      alert('Errore durante l’aggiunta al carrello.');
    }
  }

  function openSummaryWindow(items, preorder = null, existingWindow = null) {
    if (!items || !items.length) {
      alert('Nessun prodotto selezionato.');
      return;
    }

    const totalOrder = isPreordineApproved
      ? items.reduce((sum, it) => sum + it.totale, 0)
      : 0;

    const now = new Date();
    const dateStr = now.toLocaleDateString('it-IT', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const customer = getCustomerInfo();
    const preorderNumber = preorder?.preorder_number || '';
    const plainText = buildPlainText(items, totalOrder, dateStr, preorderNumber);

    const win = existingWindow || window.open('', '_blank');
    if (!win) {
      alert('Impossibile aprire la finestra di riepilogo (popup bloccato?).');
      return;
    }

    const html = `<!DOCTYPE html>
<html lang="it">
<head>
  <meta charset="utf-8">
  <title>${preorderNumber ? escapeHtml(preorderNumber) + ' – ' : ''}Pre-ordine – Riepilogo</title>
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style>
    :root {
      color-scheme: light;
      --page-bg: #f5efe6;
      --card-bg: #ffffff;
      --text-main: #2c2c2c;
      --text-muted: #666666;
      --accent: #6b4e3d;
      --border: rgba(0,0,0,.08);
    }
    * { box-sizing: border-box; }
    body {
      margin: 0;
      padding: 2rem 1.5rem 2.5rem;
      font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", system-ui, -system-ui, sans-serif;
      background: var(--page-bg);
      color: var(--text-main);
      line-height: 1.5;
    }
    .page-width {
      max-width: 960px;
      margin: 0 auto;
    }
    header {
      margin-bottom: 1.75rem;
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      gap: 1rem;
    }
    .title {
      font-size: 1.75rem;
      font-weight: 600;
      letter-spacing: -0.01em;
      line-height: 1.25;
    }
    .subtitle {
      font-size: 1rem;
      color: var(--text-muted);
      line-height: 1.5;
    }
    .card {
      background: var(--card-bg);
      border-radius: 14px;
      border: 1px solid var(--border);
      padding: 1.5rem 1.75rem;
      box-shadow: 0 12px 30px rgba(0,0,0,.02);
    }
    .customer-meta {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: .9rem 1.25rem;
      margin: 1rem 0 1.35rem;
      padding: 1rem 1.1rem;
      border: 1px solid rgba(0,0,0,.06);
      border-radius: 12px;
      background: rgba(107,78,61,.035);
    }
    .customer-meta__row {
      min-width: 0;
    }
    .customer-meta__label {
      display: block;
      margin-bottom: .2rem;
      font-size: .72rem;
      letter-spacing: .05em;
      text-transform: uppercase;
      color: var(--text-muted);
    }
    .customer-meta__value {
      display: block;
      font-size: .96rem;
      line-height: 1.45;
      font-weight: 600;
      overflow-wrap: anywhere;
    }
    .summary-block + .summary-block {
      margin-top: 1.5rem;
      padding-top: 1.5rem;
      border-top: 1px solid rgba(0,0,0,.08);
    }
    .summary-block__header {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      gap: 1rem;
      margin-bottom: .7rem;
    }
    .summary-block__title {
      margin: 0;
      font-size: 1rem;
      font-weight: 700;
      letter-spacing: .02em;
      color: var(--text-main);
    }
    .summary-block__subtotal {
      margin-top: .9rem;
      display: flex;
      justify-content: flex-end;
      gap: .9rem;
      font-size: .95rem;
      align-items: baseline;
    }
    .summary-block__subtotal strong {
      font-size: 1rem;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      font-size: .9rem;
    }
    thead th {
      text-align: left;
      font-weight: 600;
      font-size: .78rem;
      letter-spacing: .04em;
      text-transform: uppercase;
      color: var(--text-muted);
      padding: 0 0 .75rem 0;
      border-bottom: 1px solid var(--border);
    }
    tbody td {
      padding: .65rem 0;
      border-bottom: 1px solid rgba(0,0,0,.04);
      vertical-align: top;
    }
    td.right {
      text-align: right;
      white-space: nowrap;
    }
    th.num-col,
    td.num-col {
      font-variant-numeric: tabular-nums;
    }
    th.col-price,
    td.col-price {
      min-width: 7.25rem;
      padding-right: 1.35rem;
    }
    th.col-qty,
    td.col-qty {
      min-width: 4.75rem;
      padding-left: 1.35rem;
      border-left: 1px solid rgba(0,0,0,.08);
    }
    th.col-extra,
    td.col-extra {
      min-width: 3.5rem;
      padding-left: .9rem;
    }
    th.col-total,
    td.col-total {
      min-width: 7.5rem;
      padding-left: 1.1rem;
    }
    .linea {
      font-size: .84rem;
      text-transform: uppercase;
      letter-spacing: .04em;
      color: var(--text-muted);
    }
    .product-name {
      font-weight: 500;
    }
    .totale {
      margin-top: 1.2rem;
      display: flex;
      justify-content: flex-end;
      gap: 1rem;
      font-size: 1rem;
      align-items: baseline;
    }
    .totale strong {
      font-size: 1.1rem;
    }
    .actions {
      margin-top: 1.75rem;
      display: flex;
      flex-wrap: wrap;
      gap: .75rem;
    }
    button {
      appearance: none;
      border-radius: 999px;
      border: 1px solid var(--accent);
      padding: .6rem 1.1rem;
      font-size: .9rem;
      font-weight: 600;
      letter-spacing: 0;
      cursor: pointer;
      background: #fff;
      color: var(--accent);
    }
    button.primary {
      background: var(--accent);
      color: #fff;
    }
    button.ghost {
      background: transparent;
      color: var(--text-muted);
      border-color: rgba(0,0,0,.14);
    }
    button:active { transform: translateY(1px); }
    #preordine-summary-text {
      white-space: pre-wrap;
      word-break: break-word;
      margin-top: 1.5rem;
      padding-top: 1rem;
      border-top: 1px dashed rgba(0,0,0,.12);
      font-size: .8rem;
      color: var(--text-muted);
    }
    @media print {
      body {
        padding: 0;
        background: #fff;
      }
      .card {
        border-radius: 0;
        border: none;
        box-shadow: none;
      }
      .actions { display: none; }
    }
    @media (max-width: 720px) {
      .customer-meta {
        grid-template-columns: 1fr;
      }
    }
  </style>
</head>
<body>
  <div class="page-width">
    <header>
      <div>
        <div class="title">${preorderNumber ? escapeHtml(preorderNumber) : 'Pre-ordine ELS'}</div>
        <div class="subtitle">Riepilogo pre-ordine · Data: ${dateStr}</div>
        <p class="subtitle" style="margin-top:.25rem;">Documento riepilogativo della selezione.</p>
      </div>
    </header>

    <section class="card">
      ${buildCustomerDetailsHtml(customer, preorderNumber)}
      ${buildSummaryBlocksHtml(items)}

      ${isPreordineApproved ? `<div class="totale"><span>Totale pre-ordine</span><strong>${formatPrice(totalOrder)}</strong></div>` : '<p style="margin-top:1rem;font-size:.9rem;color:#666;">Un referente ELS ti contattera\' per la quotazione.</p>'}

      <div class="actions">
        <button class="primary" id="btn-print">Stampa / Salva PDF</button>
        <button id="btn-share">Condividi</button>
        <button id="btn-email">Invia email</button>
        <button id="btn-copy">Copia riepilogo</button>
        <button class="ghost" id="btn-close">Chiudi finestra</button>
      </div>
      <p id="email-note" hidden style="margin-top:.75rem;font-size:.8rem;color:#888;line-height:1.45;">
        ℹ️ La selezione e' lunga: il riepilogo viene copiato automaticamente negli appunti.
        Per la versione completa usa <strong>Stampa / Salva PDF</strong>.
      </p>

      <pre id="preordine-summary-text">${escapeHtml(plainText)}</pre>
    </section>
  </div>

  <script>
    (function () {
      var btnPrint = document.getElementById('btn-print');
      var btnCopy = document.getElementById('btn-copy');
      var textEl = document.getElementById('preordine-summary-text');

      if (btnPrint) {
        btnPrint.addEventListener('click', function () {
          window.print();
        });
      }

      function copyFallback(text) {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.top = '0';
        ta.style.left = '0';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        try {
          document.execCommand('copy');
          alert('Riepilogo copiato negli appunti.');
        } catch (e) {
          alert('Impossibile copiare automaticamente. Seleziona e copia il testo manualmente.');
        }
        document.body.removeChild(ta);
      }

      if (btnCopy && textEl) {
        btnCopy.addEventListener('click', function () {
          var text = textEl.innerText || textEl.textContent || '';
          if (!text) return;
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard
              .writeText(text)
              .then(function () {
                btnCopy.textContent = '✓ Copiato';
                setTimeout(function () { btnCopy.textContent = 'Copia riepilogo'; }, 2000);
              })
              .catch(function () { copyFallback(text); });
          } else {
            copyFallback(text);
          }
        });
      }

      var btnShare = document.getElementById('btn-share');
      if (btnShare) {
        var summaryText = (textEl && (textEl.innerText || textEl.textContent || '')) || '';
        if (navigator.share) {
          btnShare.addEventListener('click', function () {
            navigator.share({
              title: 'Pre-ordine ELS',
              text: summaryText,
            }).catch(function (err) {
              if (err && err.name !== 'AbortError') {
                copyFallback(summaryText);
              }
            });
          });
        } else {
          // Fallback desktop: copia negli appunti + messaggio guida
          btnShare.textContent = 'Copia e condividi';
          btnShare.addEventListener('click', function () {
            if (!summaryText) return;
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(summaryText).then(function () {
                alert('Riepilogo copiato negli appunti. Incollalo dove preferisci (WhatsApp, email, Teams…).');
              }).catch(function () { copyFallback(summaryText); });
            } else {
              copyFallback(summaryText);
              alert('Riepilogo copiato negli appunti. Incollalo dove preferisci.');
            }
          });
        }
      }

      var btnClose = document.getElementById('btn-close');
      if (btnClose) {
        btnClose.addEventListener('click', function () {
          window.close();
          setTimeout(function () {
            if (!window.closed) {
              alert('Puoi chiudere questa scheda manualmente.');
            }
          }, 150);
        });
      }

      var btnEmail = document.getElementById('btn-email');
      var emailNote = document.getElementById('email-note');
      if (btnEmail) {
        var emailText = (textEl && (textEl.innerText || textEl.textContent || '')) || '';
        var emailSubject = 'Pre-ordine ELS';
        var MAILTO_MAX = 1600;
        var emailIsLong = emailText.length > MAILTO_MAX;

        if (emailIsLong && emailNote) {
          emailNote.hidden = false;
        }

        btnEmail.addEventListener('click', function () {
          var emailBody;
          if (emailIsLong) {
            // Testo troppo lungo per mailto: — copia negli appunti e apre il client con guida
            var guide = '[Incolla qui il riepilogo copiato negli appunti]';
            emailBody = guide;
            var copyAndOpen = function () {
              window.location.href = 'mailto:?subject=' + encodeURIComponent(emailSubject) + '&body=' + encodeURIComponent(emailBody);
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(emailText).then(copyAndOpen).catch(function () {
                copyFallback(emailText);
                copyAndOpen();
              });
            } else {
              copyFallback(emailText);
              copyAndOpen();
            }
          } else {
            emailBody = emailText;
            window.location.href = 'mailto:?subject=' + encodeURIComponent(emailSubject) + '&body=' + encodeURIComponent(emailBody);
          }
        });
      }
    })();
  </script>
</body>
</html>`;

    win.document.open();
    win.document.write(html);
    win.document.close();
  }

  async function handleGeneratePreordine(event) {
    event.preventDefault();
    const items = collectSelectedItems();
    if (!items.length) {
      alert('Nessun prodotto selezionato.');
      return;
    }
    const totalOrder = isPreordineApproved
      ? items.reduce((sum, it) => sum + it.totale, 0)
      : 0;
    let preorder = activePreorder;
    const pendingWindow = preorderApiUrl ? window.open('', '_blank') : null;
    if (preorderApiUrl && !pendingWindow) {
      alert('Impossibile aprire la finestra di riepilogo (popup bloccato?).');
      return;
    }
    if (pendingWindow) {
      pendingWindow.document.write('<!doctype html><title>Generazione preordine</title><p style="font-family:system-ui;padding:24px;">Generazione numero preordine...</p>');
      pendingWindow.document.close();
    }
    try {
      preorder = await createServerPreorder(items, totalOrder);
    } catch (error) {
      console.error('Creazione numero preordine non riuscita', error);
      preorder = null;
    }
    openSummaryWindow(items, preorder, pendingWindow);
    if (preorder?.preorder_number) {
      await updateServerPreorderStatus('pdf_generated');
    }
  }

  if (!jsonUrl) {
    setLoading(false);
    setEmptyState(true);
    return;
  }

  setLoading(true);

  function normalizeCollections(rawData) {
    if (Array.isArray(rawData?.collections)) {
      return rawData.collections
        .map((collection) => ({
          collezione: collection?.collezione || '',
          ordine: collection?.ordine || 0,
          linee: Array.isArray(collection?.linee)
            ? Array.from(
                collection.linee.reduce((map, line, index) => {
                  const rawLabel = normalizeLineLabel(line?.linea || '');
                  const key = normalizeLineKey(rawLabel);
                  if (!key) return map;

                  const existing = map.get(key);
                  const products = Array.isArray(line?.prodotti) ? line.prodotti : [];
                  if (!existing) {
                    map.set(key, {
                      linea: rawLabel,
                      ordine: Number.isFinite(Number(line?.ordine)) ? Number(line.ordine) : index + 1,
                      prodotti: [...products],
                    });
                    return map;
                  }

                  existing.prodotti.push(...products);
                  if (
                    rawLabel &&
                    (!existing.linea ||
                      /[.]$/.test(existing.linea) ||
                      rawLabel.length < existing.linea.length)
                  ) {
                    existing.linea = rawLabel;
                  }
                  if (
                    Number.isFinite(Number(line?.ordine)) &&
                    (!Number.isFinite(Number(existing.ordine)) || Number(line.ordine) < existing.ordine)
                  ) {
                    existing.ordine = Number(line.ordine);
                  }
                  return map;
                }, new Map()).values()
              )
                .map((line) => ({
                  ...line,
                  prodotti: Array.from(
                    new Map(
                      line.prodotti.map((product) => [
                        String(product?.codice || product?.sku || '').trim(),
                        product,
                      ])
                    ).values()
                  ).sort((a, b) => compareSkuValues(a?.codice || a?.sku, b?.codice || b?.sku)),
                }))
                .sort((a, b) => {
                  const leftOrder = Number.isFinite(Number(a?.ordine)) ? Number(a.ordine) : Number.POSITIVE_INFINITY;
                  const rightOrder = Number.isFinite(Number(b?.ordine)) ? Number(b.ordine) : Number.POSITIVE_INFINITY;
                  if (leftOrder !== rightOrder) return leftOrder - rightOrder;
                  return compareLineLabels(a?.linea, b?.linea);
                })
                .filter((line) => line.prodotti.length > 0)
            : [],
        }))
        .sort((a, b) => {
          const leftOrder = Number.isFinite(Number(a?.ordine)) ? Number(a.ordine) : Number.POSITIVE_INFINITY;
          const rightOrder = Number.isFinite(Number(b?.ordine)) ? Number(b.ordine) : Number.POSITIVE_INFINITY;
          if (leftOrder !== rightOrder) return leftOrder - rightOrder;
          return String(a?.collezione || '').localeCompare(String(b?.collezione || ''), 'it-IT', {
            numeric: true,
            sensitivity: 'base',
          });
        })
        .filter((collection) => collection.linee.length > 0);
    }

    return [];
  }

  function indexProducts(collections) {
    productIndex.clear();
    collections.forEach((collection) => {
      collection.linee.forEach((line) => {
        line.prodotti.forEach((product) => {
          const codice = product.codice || product.sku || '';
          if (!codice || productIndex.has(codice)) return;
          productIndex.set(codice, {
            ...product,
            codice,
            collezione: product.collezione || collection.collezione,
            linea: product.linea || line.linea,
          });
        });
      });
    });
  }

  function buildSectionRow(collection, line) {
    const tr = document.createElement('tr');
    tr.className = 'preordine__section-row';
    tr.dataset.collectionKey = normalizeCollectionKey(collection.collezione);
    tr.dataset.lineKey = normalizeLineKey(line.linea);

    const td = document.createElement('td');
    td.colSpan = 5;
    td.className = 'preordine__section-cell';
    td.textContent = [collection.collezione, line.linea].filter(Boolean).join(' · ');
    tr.appendChild(td);
    return tr;
  }

  function buildProductRow(collection, line, product) {
    const tr = document.createElement('tr');
    const collectionKey = normalizeCollectionKey(collection.collezione);
    const lineKey = normalizeLineKey(line.linea);
    const codice = product.codice || product.sku || '';
    const displayFormat = product.ml != null ? product.ml : product.formato;

    tr.dataset.collezione = collection.collezione;
    tr.dataset.collectionKey = collectionKey;
    tr.dataset.linea = line.linea;
    tr.dataset.lineKey = lineKey;
    if (displayFormat != null && displayFormat !== '') tr.dataset.ml = String(displayFormat);
    if (product.handle) tr.dataset.handle = product.handle;
    if (product.venditore) tr.dataset.venditore = product.venditore;
    if (product.shopify_status) tr.dataset.shopifyStatus = product.shopify_status;

    const tdCode = document.createElement('td');
    tdCode.className = 'preordine__td--code';
    tdCode.textContent = codice;
    tr.appendChild(tdCode);

    const tdName = document.createElement('td');
    tdName.className = 'preordine__td--product';
    const main = document.createElement('div');
    main.className = 'preordine__product-name';
    main.textContent = String(product.nome || '').toUpperCase();
    const meta = document.createElement('div');
    meta.className = 'preordine__meta';
    meta.textContent = [collection.collezione, line.linea].filter(Boolean).join(' · ');
    tdName.appendChild(main);
    if (meta.textContent) {
      tdName.appendChild(meta);
    }
    tr.appendChild(tdName);

    const tdPrice = document.createElement('td');
    tdPrice.className = 'preordine__td--price';
    const rawPrice = product.prezzo;
    const price = typeof rawPrice === 'number' ? rawPrice : parseFloat(rawPrice || 0) || 0;
    const hasCommercialPrice = rawPrice !== null && rawPrice !== undefined && rawPrice !== '';
    if (isPreordineApproved) {
      tdPrice.textContent = hasCommercialPrice && price > 0 ? formatPrice(price) : '';
    } else {
      const span = document.createElement('span');
      span.className = 'preordine__price-reserved';
      span.textContent = 'Riservato';
      tdPrice.appendChild(span);
    }
    tr.appendChild(tdPrice);

    const tdQty = document.createElement('td');
    tdQty.className = 'preordine__td--qty';
    const paidInput = document.createElement('input');
    paidInput.type = 'number';
    paidInput.min = '0';
    paidInput.step = '1';
    paidInput.inputMode = 'numeric';
    paidInput.autocomplete = 'off';
    paidInput.className = 'preordine__input';
    paidInput.value = quantityState.get(codice) ? String(quantityState.get(codice)) : '';
    paidInput.setAttribute('data-preordine-price', String(price));
    paidInput.setAttribute('data-preordine-code', codice);
    paidInput.setAttribute('aria-label', `Quantità ${product.nome || codice}`);
    paidInput.addEventListener('input', () => {
      const nextQty = parseFloat((paidInput.value || '').replace(',', '.')) || 0;
      if (nextQty > 0) {
        quantityState.set(codice, nextQty);
      } else {
        quantityState.delete(codice);
      }
      recalcTotal();
    });
    tdQty.appendChild(paidInput);
    tr.appendChild(tdQty);

    const tdExtra = document.createElement('td');
    tdExtra.className = 'preordine__td--extra';
    const extraInput = document.createElement('input');
    extraInput.type = 'number';
    extraInput.min = '0';
    extraInput.step = '1';
    extraInput.inputMode = 'numeric';
    extraInput.autocomplete = 'off';
    extraInput.className = 'preordine__input';
    extraInput.value = extraQuantityState.get(codice) ? String(extraQuantityState.get(codice)) : '';
    extraInput.setAttribute('data-preordine-extra-code', codice);
    extraInput.setAttribute('aria-label', `Quantità aggiuntiva ${product.nome || codice}`);
    extraInput.addEventListener('input', () => {
      const nextQty = parseFloat((extraInput.value || '').replace(',', '.')) || 0;
      if (nextQty > 0) {
        extraQuantityState.set(codice, nextQty);
      } else {
        extraQuantityState.delete(codice);
      }
      recalcTotal();
    });
    tdExtra.appendChild(extraInput);
    tr.appendChild(tdExtra);

    return tr;
  }

  function parseManualPrice(value) {
    const normalized = String(value || '').replace(/\s/g, '').replace(',', '.');
    const parsed = parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function updateManualLine(id, field, value) {
    const line = manualLines.find((item) => item.id === id);
    if (!line) return;
    if (field === 'prezzo') {
      line.prezzo = parseManualPrice(value);
    } else if (field === 'quantita') {
      line.quantita = parseFloat(String(value || '').replace(',', '.')) || 0;
    } else if (field === 'quantitaExtra') {
      line.quantitaExtra = parseFloat(String(value || '').replace(',', '.')) || 0;
    } else {
      line[field] = String(value || '').trim();
    }
    recalcTotal();
  }

  function buildManualLineRow(line) {
    const tr = document.createElement('tr');
    tr.className = 'preordine__manual-row';
    tr.dataset.manualLineId = String(line.id);

    const fields = [
      ['codice', 'Codice prodotto', 'text', 'Codice'],
      ['nome', 'Prodotto', 'text', 'Prodotto'],
      ['prezzo', 'Prezzo', 'text', '0,00'],
      ['quantita', 'Quantità', 'number', '0'],
      ['quantitaExtra', 'Omaggio / incluso', 'number', '0'],
    ];

    fields.forEach(([field, label, type, placeholder]) => {
      const td = document.createElement('td');
      td.className = field === 'nome' ? 'preordine__td--product' : field === 'prezzo' ? 'preordine__td--price' : field === 'quantita' ? 'preordine__td--qty' : field === 'quantitaExtra' ? 'preordine__td--extra' : 'preordine__td--code';
      const input = document.createElement('input');
      input.type = type;
      if (type === 'number') {
        input.min = '0';
        input.step = '1';
        input.inputMode = 'numeric';
      }
      if (field === 'prezzo') input.inputMode = 'decimal';
      input.autocomplete = 'off';
      input.className = `preordine__input preordine__manual-input preordine__manual-input--${field}`;
      input.placeholder = placeholder;
      input.setAttribute('aria-label', `${label} linea manuale`);
      input.value = line[field] ? String(line[field]) : '';
      input.addEventListener('input', () => updateManualLine(line.id, field, input.value));
      td.appendChild(input);
      tr.appendChild(td);
    });

    return tr;
  }

  function renderManualLines() {
    if (!manualBody) return;
    manualBody.innerHTML = '';
    manualLines.forEach((line) => {
      manualBody.appendChild(buildManualLineRow(line));
    });
  }

  function addManualLine() {
    manualLines.push({
      id: Date.now() + Math.floor(Math.random() * 1000),
      codice: '',
      nome: '',
      prezzo: 0,
      quantita: 0,
      quantitaExtra: 0,
    });
    renderManualLines();
    recalcTotal();
  }

  function renderVisibleRows() {
    tbody.innerHTML = '';

    const activeCollection = getActiveCollection();
    if (!activeCollection) {
      tbody.appendChild(buildNoResultsRow('Listino non disponibile.'));
      return;
    }

    const query = getSearchQuery();
    const lines = Array.isArray(activeCollection.linee) ? activeCollection.linee : [];
    const visibleLines = lines.filter((line) => {
      const matchesLine = !activeLineFilter || normalizeLineKey(line.linea) === activeLineFilter;
      if (!matchesLine) return false;
      if (!query) return true;
      return line.prodotti.some((product) => {
        const code = String(product.codice || product.sku || '').toLowerCase();
        const name = String(product.nome || '').toLowerCase();
        return code.includes(query) || name.includes(query);
      });
    });

    if (!visibleLines.length) {
      tbody.appendChild(buildNoResultsRow('Nessun prodotto trovato nella selezione attiva.'));
      return;
    }

    visibleLines.forEach((line) => {
      const matchingProducts = (Array.isArray(line.prodotti) ? line.prodotti : []).filter((product) => {
        if (!query) return true;
        const code = String(product.codice || product.sku || '').toLowerCase();
        const name = String(product.nome || '').toLowerCase();
        return code.includes(query) || name.includes(query);
      });

      if (!matchingProducts.length) return;

      tbody.appendChild(buildSectionRow(activeCollection, line));
      matchingProducts.forEach((product) => {
        tbody.appendChild(buildProductRow(activeCollection, line, product));
      });
    });
  }

  fetch(jsonUrl, { credentials: 'same-origin' })
    .then((res) => {
      if (!res.ok) throw new Error('Errore caricamento listino');
      return res.json();
    })
    .then((data) => {
      collectionsData = normalizeCollections(data);
      if (!collectionsData.length) {
        setEmptyState(true);
        return;
      }

      setEmptyState(false);
      indexProducts(collectionsData);
      if (!activeCollectionFilter && collectionsData.length) {
        activeCollectionFilter = normalizeCollectionKey(collectionsData[0].collezione);
      }
      renderDynamicCollectionFilters(collectionsData);
      renderDynamicLineFilters(collectionsData, activeCollectionFilter);
      renderVisibleRows();
      recalcTotal();
    })
    .catch(() => {
      setEmptyState(true);
    });

  if (searchInput) {
    searchInput.addEventListener('input', () => {
      renderVisibleRows();
    });
  }

  if (addManualLineButton) {
    addManualLineButton.addEventListener('click', addManualLine);
  }

  addManualLine();

  // Event delegation per Genera pre-ordine
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-preordine-pdf]');
    if (!trigger) return;
    handleGeneratePreordine(event);
  });

  // Listener diretto per Aggiungi al carrello
  btnCarts.forEach((btn) => {
    if (!btn) return;
    btn.addEventListener('click', addToCartSelected);
  });
});
